import { render, staticRenderFns } from "./CreaAsseverazione.vue?vue&type=template&id=7820d295&scoped=true&"
import script from "./CreaAsseverazione.vue?vue&type=script&lang=js&"
export * from "./CreaAsseverazione.vue?vue&type=script&lang=js&"
import style0 from "./CreaAsseverazione.vue?vue&type=style&index=0&id=7820d295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7820d295",
  null
  
)

export default component.exports